// @flow

import ApiError from '../../entities/ApiError';
import ApiErrorUtils from '../ApiErrorUtils';
import I18n from '../../i18n/I18n';

export default class ProRoleApiErrors {

  static getOne(apiError: ApiError): string {
    const errors = {
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'ProRoleApiErrors:getOne');
  };
}
